import React, { useEffect, useContext, useState } from "react";
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import FormHelperText from "@material-ui/core/FormHelperText";
import { SessionContext } from "beaktShared/services/session";

// icons
import PermIdentity from "@material-ui/icons/PermIdentity";
import Check from "@material-ui/icons/Check";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Clearfix from "beaktShared/components/Clearfix/Clearfix.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import CircularProgress from '@material-ui/core/CircularProgress';

// services
import { UsePostApi, UsePutApi } from "beaktShared/services/crudeApiService";

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
const useStyles = makeStyles(styles);

export default function GatewayForm({ item, handleView }) {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const classes = useStyles();
    const { register, handleSubmit, setValue, errors } = useForm({ mode: "onChange" });
    const [ativoCheckbox, setAtivoCheckbox] = useState(true);
    const [loading, setLoading] = useState(false);

    const [notification, setNotification] = useState(false);
    const [colorNotification, setColorNotification] = useState('info');
    const [mensagemNotification, setMensagemNotification] = useState(false);
    const showNotification = (mensagem, color) => {
        setMensagemNotification(mensagem);
        setColorNotification(color);
        setNotification(true);
        setTimeout(function () {
            setNotification(false);
        }, 6000);
    };

    useEffect(() => {
        loadDadosItem();
    }, [item]);

    const loadDadosItem = () => {
        if (item != null) {
            setValue('descricao', item.descricao);
            setValue('tipo', item.tipo);
            setValue('url', item.url);
            setValue('loja', item.loja);
            setValue('usuario', item.usuario);
            setValue('senha', item.senha);
            setAtivoCheckbox(item.ativo !== false); // Default to true if not set
        }
    }

    const onSubmit = data => {
        let json_submit = {
            gatewayId: item != null ? item.gatewayId : 0,
            descricao: data.descricao,
            tipo: data.tipo,
            url: data.url,
            loja: data.loja,
            usuario: data.usuario,
            senha: data.senha,
            ativo: ativoCheckbox
        }

        setLoading(true);
        if (item && item.gatewayId && item.gatewayId > 0) {
            UsePutApi("Gateways", "", json_submit).then(result => {
                if (result.status !== 200) {
                    showNotification(result.message || 'Erro ao salvar registro.', 'danger');
                    setLoading(false);
                    return false;
                }
                showNotification('Registro salvo com sucesso!', 'success');
                setTimeout(() => {
                    handleView(true, result.data || json_submit);
                    setLoading(false);
                    return true;
                }, 2000);
            });
        }
        else {
            UsePostApi("Gateways", json_submit).then(result => {
                if (result.status !== 200) {
                    showNotification(result.message || 'Erro ao salvar registro.', 'danger');
                    setLoading(false);
                    return false;
                }
                showNotification('Registro salvo com sucesso!', 'success');
                setTimeout(() => {
                    handleView(true, result.data || json_submit);
                    setLoading(false);
                    return true;
                }, 2000);
            });
        }
    };

    const handleViewForm = () => {
        handleView();
    };

    return (
        <div className="maxContent">
            <Snackbar
                place="tr"
                color={colorNotification}
                message={mensagemNotification}
                open={notification}
                closeNotification={() => setNotification(false)}
                close
            />
            {loading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <label>{t('label.loading')}...</label>
                        <CircularProgress />
                    </div>
                </div>
            }
            <form onSubmit={handleSubmit(onSubmit)}>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="primary" icon>
                                <CardIcon color="primary">
                                    <PermIdentity />
                                </CardIcon>
                                <h4 className={classes.cardIconTitle}>
                                    {item && item.gatewayId ? "Editar Gateway" : "Novo Gateway"} - <small>{t('information_message.fill_in_your_details')}</small>
                                </h4>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                error={errors.descricao ? true : false}
                                                label={"Descrição *"}
                                                variant="outlined"
                                                inputRef={register({ required: true })}
                                                name="descricao"
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    maxLength: 150,
                                                }}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.descricao && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                error={errors.tipo ? true : false}
                                                label={"Tipo"}
                                                variant="outlined"
                                                inputRef={register({ required: false })}
                                                name="tipo"
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    maxLength: 150,
                                                }}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.tipo && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                </GridContainer>
                                <GridContainer>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                error={errors.url ? true : false}
                                                label={"URL"}
                                                variant="outlined"
                                                inputRef={register({ required: false })}
                                                name="url"
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    maxLength: 255,
                                                }}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.url && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                error={errors.loja ? true : false}
                                                label={"Loja"}
                                                variant="outlined"
                                                inputRef={register({ required: false })}
                                                name="loja"
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    maxLength: 150,
                                                }}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.loja && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                </GridContainer>
                                <GridContainer>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                error={errors.usuario ? true : false}
                                                label={"Usuário"}
                                                variant="outlined"
                                                inputRef={register({ required: false })}
                                                name="usuario"
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    maxLength: 150,
                                                }}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.usuario && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={6}>
                                        <FormControl fullWidth className={classes.formControl}>
                                            <TextField
                                                error={errors.senha ? true : false}
                                                label={"Senha"}
                                                variant="outlined"
                                                inputRef={register({ required: false })}
                                                name="senha"
                                                InputLabelProps={{ shrink: true }}
                                                InputProps={{
                                                    maxLength: 150,
                                                }}
                                            />
                                            <FormHelperText className={classes.labelRootError}>
                                                {errors.senha && <span>{t('label.required')}</span>}
                                            </FormHelperText>
                                        </FormControl>
                                    </GridItem>
                                </GridContainer>
                                <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    tabIndex={-1}
                                                    checked={ativoCheckbox}
                                                    onClick={event => { setAtivoCheckbox(event.target.checked) }}
                                                    checkedIcon={<Check className={classes.checkedIcon} />}
                                                    icon={<Check className={classes.uncheckedIcon} />}
                                                    classes={{
                                                        checked: classes.checked,
                                                        root: classes.checkRoot
                                                    }}
                                                    name="ativo"
                                                    inputRef={register}
                                                />
                                            }
                                            classes={{
                                                label: classes.label,
                                                root: classes.labelRoot
                                            }}
                                            label={t('information_message.system_active')}></FormControlLabel>
                                    </GridItem>
                                </GridContainer>
                                <Clearfix />
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
                <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                        <br />
                        <div className={classes.textCenter}>
                            <Button onClick={() => handleViewForm()} color="transparent" className={classes.updateProfileButton}>
                                {t('button.cancel')}
                            </Button>
                            <Button type="submit" color="primary" className={classes.updateProfileButton} disabled={loading}>
                                {t('button.to_save')}
                                {loading && <div>{t('label.loading') + "..."}</div>}
                            </Button>
                        </div>
                    </GridItem>
                </GridContainer>
            </form>
        </div>
    );
}
